import React from 'react';
import { useRecoilValue } from 'recoil';
import { userState } from '../state/RecoilState';
import MfsDashboard from '../components/Dashboard/MfsDashboard';
import SeoDashboard from '../components/Dashboard/SeoDashboard';
import BandDashboard from '../components/Dashboard/BandDashboard';

const DashboardWrapper = () => {
  const user = useRecoilValue<any>(userState);
  if (user?.role === 'Administrator') return <MfsDashboard />;
  if (user?.role === 'ContentAdmin') return <SeoDashboard />;
  else return <BandDashboard />;
};

export default DashboardWrapper;
